import React, { useState, useEffect, useContext } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  FormControlLabel,
  Checkbox,
  Input,
} from "@material-ui/core";
import AddIcon from "@material-ui/icons/Add";
import { Button } from "../ui/forms/Button";
import EnhancedTable from "../ui/Table/Enhanced/EnhancedTable";
import SiteForm from "./SiteForm";
import { UserContext } from "../../contexts/UserContext";
import { useFormik } from "formik";
import * as Yup from "yup";
import Axios from "axios";
import SearchIcon from "@material-ui/icons/Search";

export const Sites = () => {
  const [deleteOpen, setDeleteOpen] = useState(false);
  const [editOpen, setEditOpen] = useState(false);
  const [createOpen, setCreateOpen] = useState(false);
  const [siteToEdit, setSiteToEdit] = useState();
  const [Rows1, setRows1] = useState([]);
  const [filterValue, setFilter] = useState("");
  const [ShowAllSites, setShowAllSites] = useState(false);
  const [filterColumn, setFilterColumn] = useState("name");

  const {
    handleSubmit,
    handleChange,
    handleBlur,
    handleReset,
    values,
    touched,
    errors,
    setValues,
  } = useFormik({
    initialValues: {
      //ShowAllSites: false,
    },
    validationSchema: Yup.object({
      //ShowAllSites: Yup.boolean().nullable(),
    }),
  });

  const [columns] = useState([
    {
      id: "siteCode",
      disablePadding: false,
      label: "Site Code",
    },
    {
      id: "name",
      disablePadding: false,
      label: "Name",
    },
    {
      id: "siteType",
      disablePadding: false,
      label: "Site Type",
    },
    {
      id: "userNumber",
      disablePadding: false,
      label: "No. of Users",
      align: "right",
    },
    {
      id: "action",
      disablePadding: false,
      label: "Actions",
      align: "right",
    },
  ]);
  const [rows, setRows] = useState([]);

  const { getAllSites, deleteSite, Allfiltersites1, getSearchSites } =
    useContext(UserContext);

  const handleDialog = (dialog, data) => {
    if (dialog !== "create" && !data) {
      setDeleteOpen(false);
      setCreateOpen(false);
      setEditOpen(false);
      setSiteToEdit(null);
      return;
    }
    if (dialog === "create") {
      setCreateOpen(true);
      setSiteToEdit(null);
    } else if (dialog === "delete") {
      setSiteToEdit(data);
      setDeleteOpen(true);
    } else {
      setSiteToEdit(data);
      setEditOpen(true);
    }
  };

  const handleDelete = () => {
    if (siteToEdit) {
      deleteSite(siteToEdit.siteCode).then(() => {
        setDeleteOpen(false);
        refreshSites();
      });
    }
  };

  const refreshSites = () => {
    getAllSites()
      .then((sites) => {
        let rowData = [];
        if (ShowAllSites === false) {
          sites.forEach((site) => {
            if (site.userNumber > 0) {
              rowData.push({
                key: site.siteCode,
                siteCode: site.siteCode,
                name: site.name,
                siteType:
                  site.siteType === 0
                    ? "SmartRider"
                    : site.siteType === 2
                    ? "MyWayDriver"
                    : site.siteType === 3
                    ? "SmartRider (Driver)"
                    : site.siteType === 4
                    ? "MonDemoQLD"
                    : site.siteType === 5
                    ? "MyWay"
                    : site.siteType === 6
                    ? "DepOfCommunities"
                    : "ID Cards",
                userNumber: site.userNumber,

                action: (
                  <>
                    <Button
                      colour="info"
                      onClick={() => handleDialog("edit", site)}
                      margin="0 1rem 0 0"
                    >
                      Edit
                    </Button>
                    <Button
                      colour="error"
                      onClick={() => handleDialog("delete", site)}
                    >
                      Delete
                    </Button>
                  </>
                ),
              });
            }
          });
        }
        if (ShowAllSites === true) {
          sites.forEach((site) => {
            rowData.push({
              key: site.siteCode,
              siteCode: site.siteCode,
              name: site.name,
              siteType:
                site.siteType === 0
                  ? "SmartRider"
                  : site.siteType === 2
                  ? "MyWayDriver"
                  : site.siteType === 3
                  ? "SmartRider (Driver)"
                  : site.siteType === 4
                  ? "MonDemoQLD"
                  : site.siteType === 5
                  ? "MyWay"
                  : site.siteType === 6
                  ? "DepOfCommunities"
                  : "ID Cards",
              userNumber: site.userNumber,

              action: (
                <>
                  <Button
                    colour="info"
                    onClick={() => handleDialog("edit", site)}
                    margin="0 1rem 0 0"
                  >
                    Edit
                  </Button>
                  <Button
                    colour="error"
                    onClick={() => handleDialog("delete", site)}
                  >
                    Delete
                  </Button>
                </>
              ),
            });
          });
        }

        setRows(rowData);

        let userNum = [];
        sites.find((item) => item.userNumber > 0);

        setRows1(userNum);
        var a = sites.find((item) => item.userNumber > 0);
      })
      .catch((err) => console.log(err));
  };

  useEffect(() => {
    setShowAllSites(true);
    refreshSites();
    //eslint-disable-next-line
  }, []);

  const HandleChange = (event) => {
    setShowAllSites(!ShowAllSites);
    refreshSites();
  };

  const searchData = async () => {
    getSearchSites(filterColumn, filterValue)
      .then((sites) => {
        let rowData = [];
        sites.forEach((site) => {
          rowData.push({
            key: site.siteCode,
            siteCode: site.siteCode,
            name: site.name,
            siteType:
              site.siteType === 0
                ? "SmartRider"
                : site.siteType === 2
                ? "MyWayDriver"
                : site.siteType === 3
                ? "SmartRider (Driver)"
                : site.siteType === 4
                ? "MonDemoQLD"
                : site.siteType === 5
                ? "MyWay"
                : site.siteType === 6
                ? "DepOfCommunities"
                : "ID Cards",
            userNumber: site.userNumber,

            action: (
              <>
                <Button
                  colour="info"
                  onClick={() => handleDialog("edit", site)}
                  margin="0 1rem 0 0"
                >
                  Edit
                </Button>
                <Button
                  colour="error"
                  onClick={() => handleDialog("delete", site)}
                >
                  Delete
                </Button>
              </>
            ),
          });
        });

        setRows(rowData);

        let userNum = [];
        sites.find((item) => item.userNumber > 0);

        setRows1(userNum);
        var a = sites.find((item) => item.userNumber > 0);
      })
      .catch((err) => console.log(err));
  };

  return (
    <>
      <button
        onClick={searchData}
        style={{ float: "right", backgroundColor: "#2E3652" }}
      >
        <SearchIcon />
      </button>
      <Input
        style={{ float: "right", backgroundColor: "#2E3652" }}
        value={filterValue || ""}
        onChange={(e) => {
          setFilter(e.target.value || undefined); // Set undefined to remove the filter entirely
        }}
        placeholder={`Search with Name`}
      />
      <EnhancedTable
        rows={rows}
        columns={columns}
        title={
          <Button
            colour="success"
            onClick={() => handleDialog("create", null)}
            startIcon={<AddIcon />}
          >
            Create Site
          </Button>
        }
        colour="error"
      />

      <FormControlLabel
        control={
          <Checkbox
            checked={!ShowAllSites}
            onChange={HandleChange}
            name="ShowAllSites"
          />
        }
        label="Show All Sites"
      />
      <Dialog open={deleteOpen} onClose={() => handleDialog()} maxWidth="md">
        <DialogTitle>Delete Site</DialogTitle>
        <DialogContent>
          <DialogContentText>
            Are you sure you want to delete this site?
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setDeleteOpen(false)}>Cancel</Button>
          <Button colour="error" onClick={handleDelete}>
            Proceed
          </Button>
        </DialogActions>
      </Dialog>
      <Dialog open={editOpen} onClose={() => handleDialog()} maxWidth="md">
        <DialogTitle>Edit Site</DialogTitle>
        <DialogContent>
          <SiteForm
            site={siteToEdit}
            close={() => handleDialog()}
            refresh={refreshSites}
          />
        </DialogContent>
      </Dialog>
      <Dialog open={createOpen} onClose={() => handleDialog()} maxWidth="md">
        <DialogTitle>Create Site</DialogTitle>
        <DialogContent>
          <SiteForm close={() => handleDialog()} refresh={refreshSites} />
        </DialogContent>
      </Dialog>
    </>
  );
};
